import styled from "styled-components";

export const Container = styled.main`
  section{
    margin: 72px auto 0;
    p{
      margin-bottom: 36px;
    }
    button{
      width: 100%;
      height: 46px;
      margin-top: 12px;
      border-radius: 6px;
    }
  }

  @media screen and (min-width: 501px){
    section{
      width: 360px;
    }
  }

  @media (max-width: 500px){
    section{
      width: 100%;
    }
  }
`